<form #displayForm="ngForm" class="my-2" *ngIf="isSearchable">
    <div class="row mb-2">
        <div class="col-12 col-md-4" *ngIf="pageSizeOptions.length">
            <div class="text--start">
                <label class="form-label me-1"><span i18n="Mostrar">Mostrar</span>
                    <select class="form-select form-select-sm  w-auto ms-1 me-1 d-inline" name="pageSize"
                        id="event-category" required [(ngModel)]="service.pageSize" (ngModelChange)="paginate()">
                        <option *ngFor="let option of pageSizeOptions" [value]="option">{{option}}</option>
                    </select>
                    <span i18n>entradas</span></label>
            </div>
        </div><!-- end col-->
        <div class="col-12" [class.col-md-8]="pageSizeOptions.length">
            <div class="d-flex align-items-center justify-content-start justify-content-sm-end">
                <!-- Botón de descarga de casos -->
                <button (click)="exportCases()" class="btn btn-primary waves-effect waves-light" icon="fe-archive"
                    style="margin-right: 20px;" *ngIf="isCasesSection && !disableNoAdmin && buttonTitle2">
                    <span class="btn-label"><i class="fe-archive"></i></span>{{buttonTitle2}}
                </button>
                <!-- Botón de Nuevo para Partes -->
                <button *ngIf="isPartesSection && !disableNoAdmin; else defaultButton" (click)="buttonClick.emit()"
                    class="btn btn-primary waves-effect waves-light" style="margin-right: 20px;">
                    <span class="btn-label"><i class="fe-user-plus"></i></span>{{buttonTitle}}
                </button>
                <!-- Botón por defecto para el resto de componentes -->
                <ng-template #defaultButton>
                    <button (click)="navigateTo(buttonLink)" class="btn btn-primary waves-effect waves-light"
                        icon="fe-user-plus" style="margin-right: 20px;" *ngIf="buttonLink != '' && !disableNoAdmin">
                        <span class="btn-label"><i class="fe-user-plus"></i></span>{{buttonTitle}}
                    </button>
                </ng-template>
                <label class="d-inline"><span i18n>Buscar:</span>
                    <input type="text" name="searchTerm" class="form-control form-control-sm d-inline w-auto ms-1"
                        aria-controls="advanced-table" [(ngModel)]="service.searchTerm" (ngModelChange)="searchData()"
                        (keydown.enter)="$event.preventDefault()">
                </label>
            </div>
        </div><!-- end col-->
    </div>
    <!-- end row -->
</form>

<div class="table-responsive">
    <!-- Botón de nuevo item-->
    <table id="advancd-table" class="table advanced-table table-nowrap mb-0" [class]="tableClasses" #advancedTable>
        <thead [class]="theadClasses">
            <tr *ngIf="isSortable">
                <!--
                <th *ngIf="hasRowSelection" class="row_select" style="width: 20px;">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="flexCheckIndeterminate"
                            [checked]="selectAll" [indeterminate]="checkIntermediate()" (change)="selectAllRow($event)">
                    </div>
                </th>
                -->

                <ng-container *ngFor="let column of columns">
                    <th class="text-capitalize sortable pe-3 pe-lg-auto" [style.width.px]="column.width"
                        [sortable]="column.name" (sort)="onSort($event)" *ngIf="column.sort!=false">
                        {{column.label}}</th>
                    <th class="text-capitalize" [style.width.px]="column.width" *ngIf="column.sort===false">
                        {{column.label}}</th>
                </ng-container>
            </tr>
            <tr *ngIf="!isSortable">
                <!--
                <th *ngIf="hasRowSelection" class="row_select" style="width: 20px;">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="flexCheckIndeterminate"
                            [checked]="selectAll" [indeterminate]="checkIntermediate()" (change)="selectAllRow($event)">
                    </div>
                </th>
                -->
                <th *ngFor="let column of columns" [style.width.px]="column.width" class="text-capitalize">
                    {{column.label}}</th>
            </tr>

            <tr *ngIf="columnFilterValues">
                <th *ngFor="let column of columns" [style.width.px]="column.width" class="p-1">
                    <input *ngIf="columnFilterValues[column.name] !== undefined" type="text"
                        class="form-control form-control-sm"
                        [ngModel]="columnFilterValues[column.name]"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onColumnFilterInput(column.name, $event)"
                        (keydown.enter)="$event.preventDefault()">
                    <span *ngIf="columnFilterValues[column.name] === undefined" class="d-block">&nbsp;</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let record of tableData | slice: (service.page-1) * service.pageSize : service.page * service.pageSize;let i=index"
                [class.selected]="isSelected[i+((service.page-1) * service.pageSize)]">

                <!--
                <td *ngIf="hasRowSelection">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox"
                            [checked]="isSelected[i+((service.page-1) * service.pageSize)]" value=""
                            id="flexCheckIndeterminate" (change)="selectRow(i+((service.page-1) * service.pageSize))">
                    </div>
                </td>
                -->

                <!-- Personalización para soportar la columna de opciones de los listados y meter funciones (click) que el innerHtml elimina -->
                <td *ngFor="let column of columns">
                    <ng-container *ngIf="column.name !== 'accionesArbitros' && column.name !== 'accionesUsuarios' 
                        && column.name !== 'accionesPlantillas' && column.name !== 'accionesCasos' && column.name !== 'accionesPartes'
                        && column.name !== 'accionesRepresentantes' && column.name !== 'accionesPagos' && column.name !== 'accionesBuscadorArchivos'
                        && column.name !== 'accionesHitosProcesales' && column.name !== 'accionesDiasInhabiles'; else accionesColumn">
                        <div [innerHtml]="callFormatter(column, record)"
                            *ngIf="column.name !== 'validado' && column.name !== 'activo' && column.name !== 'incoherencias' && column.name !== 'dias_restantes'
                            && column.name !== 'es_arbitro' && column.name !== 'es_representante' && column.name !== 'ultimoHitoDescripcion' && column.name !== 'tribunal'"></div>

                        <div *ngIf="column.name == 'validado'">
                            <i class="fe-check icono-ok align-center" *ngIf="record.validado === true"></i>
                            <i class="fe-x icono-x align-center" *ngIf="record.validado === false"></i>
                        </div>
                        <div *ngIf="column.name == 'activo'">
                            <i class="fe-check icono-ok" *ngIf="record.activo === true"></i>
                            <i class="fe-x icono-x" *ngIf="record.activo === false"></i>
                        </div>
                        <div *ngIf="column.name == 'incoherencias'">
                            <i class="fe-x icono-x align-center" *ngIf="record.anomalias === true"></i>
                            <i class="fe-check icono-ok align-center" *ngIf="record.anomalias === false"></i>
                        </div>
                        <div *ngIf="column.name == 'tribunal'">
                            <div *ngFor="let miembro of record.tribunal">
                                <span [title]="(miembro.nombre + ' ' + miembro.apellidos).length > 30 ? (miembro.nombre + ' ' + miembro.apellidos) : null">
                                    {{ truncateText(miembro.nombre + ' ' + miembro.apellidos, 30) }}
                                </span>
                            </div>
                        </div>
                        <div *ngIf="column.name == 'es_arbitro'">
                            <i class="fe-x icono-x align-center" *ngIf="record.es_arbitro === false"></i>
                            <i class="fe-check icono-ok align-center" *ngIf="record.es_arbitro === true"></i>
                        </div>
                        <div *ngIf="column.name == 'es_representante'">
                            <i class="fe-x icono-x align-center" *ngIf="record.es_representante === false"></i>
                            <i class="fe-check icono-ok align-center" *ngIf="record.es_representante === true"></i>
                        </div>
                        <div *ngIf="column.name == 'dias_restantes'">
                            <span
                                [ngStyle]="{'color': record.dias_restantes < 0 ? '#FF5B5B' : '#10C469', 'font-weight': 'bold'}"
                                class="align-center">
                                {{ record.dias_restantes }}
                            </span>
                        </div>
                        <div *ngIf="column.name == 'ultimoHitoDescripcion'">
                            <span
                                [attr.title]="record.ultimoHitoDescripcion?.length > 35 ? record.ultimoHitoDescripcion : null"
                                *ngIf="record.ultimoHitoDescripcion?.length > 35">
                                {{ (record.ultimoHitoDescripcion | slice:0:35) + '...' }}<br>
                                {{ formatDateStringWithTime(record.ultimoHitoFechaFin ?? '', currentLanguage) }}
                            </span>
                            <span *ngIf="record.ultimoHitoDescripcion?.length <= 35">
                                {{ record.ultimoHitoDescripcion }}<br>
                                {{ formatDateStringWithTime(record.ultimoHitoFechaFin ?? '', currentLanguage) }}
                            </span>
                        </div>
                    </ng-container>
                    <ng-template #accionesColumn>
                        <div>

                            <ng-container *ngIf="column.name === 'accionesArbitros'">
                                <!-- Aquí inserta el HTML necesario para la columna de acciones de árbitros -->
                                <i class='fe-edit' (click)="navigateToEdit('arbitros', record.id, true)"></i>
                                <i class='fe-file-text' (click)="genericFillAndDownloadPDF(record)" title="CV"></i>
                                <i class='fe-power' (click)="estadoClick.emit(record)"
                                    [ngClass]="record.activo === true || record.activo === 'true' || record.activo === 1 ? 'icono-estado-activo' : record.activo === false || record.activo === 'false' || record.activo === 0 ? 'icono-estado-inactivo' : ''"
                                    [attr.title]="record.activo === true ? 'Desactivar usuario' : 'Activar usuario'"
                                    [attr.aria-label]="record.activo === true ? 'Desactivar usuario' : 'Activar usuario'"></i>
                                <span
                                    [attr.title]="record.apto_borrar ? 'Borrar' : 'No se puede borrar porque el usuario esta validado o asociado a un caso.'">
                                    <i class='fe-trash-2'
                                        (click)="record.apto_borrar && navigateToDelete('arbitros',record.id)"
                                        [attr.aria-label]="record.apto_borrar ? 'Borrar' : 'No se puede borrar porque el usuario esta validado o asociado a un caso.'"
                                        [ngClass]="{ 'disabled-icon': !record.apto_borrar }"></i>
                                </span>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'accionesUsuarios'">
                                <!-- Aquí inserta el HTML necesario para la columna de acciones de usuarios -->
                                <!-- Por ejemplo: -->
                                <i class='fe-edit' (click)="navigateToEdit('usuarios',record.id, false)"></i>
                                <i class='fe-power' (click)="estadoClick.emit(record)"
                                    [ngClass]="record.activo === true || record.activo === 'true' || record.activo === 1 ? 'icono-estado-activo' : record.activo === false || record.activo === 'false' || record.activo === 0 ? 'icono-estado-inactivo' : ''"
                                    [attr.title]="record.activo === true ? 'Desactivar usuario' : 'Activar usuario'"
                                    [attr.aria-label]="record.activo === true ? 'Desactivar usuario' : 'Activar usuario'"></i>
                                <span
                                    [attr.title]="record.apto_borrar ? 'Borrar' : 'No se puede borrar porque el usuario esta validado o asociado a un caso.'">
                                    <i class='fe-trash-2'
                                        (click)="record.apto_borrar && navigateToDelete('usuarios',record.id)"
                                        [attr.aria-label]="record.apto_borrar ? 'Borrar' : 'No se puede borrar porque el usuario esta validado o asociado a un caso.'"
                                        [ngClass]="{ 'disabled-icon': !record.apto_borrar }"></i>
                                </span>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'accionesRepresentantes'">
                                <!-- Aquí inserta el HTML necesario para la columna de acciones de usuarios -->
                                <!-- Por ejemplo: -->
                                <i class='fe-edit' (click)="navigateToEdit('representantes',record.id, false)"></i>
                                <i class='fe-power' (click)="estadoClick.emit(record)"
                                    [ngClass]="record.activo === true || record.activo === 'true' || record.activo === 1 ? 'icono-estado-activo' : record.activo === false || record.activo === 'false' || record.activo === 0 ? 'icono-estado-inactivo' : ''"
                                    [attr.title]="record.activo === true ? 'Desactivar usuario' : 'Activar usuario'"
                                    [attr.aria-label]="record.activo === true ? 'Desactivar usuario' : 'Activar usuario'"></i>
                                <span
                                    [attr.title]="record.apto_borrar ? 'Borrar' : 'No se puede borrar porque el usuario esta validado o asociado a un caso.'">
                                    <i class='fe-trash-2'
                                        (click)="record.apto_borrar && navigateToDelete('representantes',record.id)"
                                        [attr.aria-label]="record.apto_borrar ? 'Borrar' : 'No se puede borrar porque el usuario esta validado o asociado a un caso.'"
                                        [ngClass]="{ 'disabled-icon': !record.apto_borrar }"></i>
                                </span>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'accionesPlantillas'">
                                <!-- Aquí inserta el HTML necesario para la columna de acciones de plantillas -->
                                <!-- Por ejemplo: -->
                                <i class='fe-folder' (click)="navigateToFolders('plantillas',record.id)"></i>
                                <i class='fe-edit' (click)="navigateToEdit('plantillas',record.id, false)"></i>
                                <i class='fe-trash-2' (click)="navigateToDelete('plantillas',record.id)"></i>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'accionesCasos'">
                                <!-- Ícono para gestionar casos -->
                                <i class='fe-clipboard'
                                    (click)="(!isEstadoCerrado(record.estado) || !disableNoAdmin) && navigateToManage('casos', record.id)"
                                    [ngClass]="{ 'disabled-icon': isEstadoCerrado(record.estado) && disableNoAdmin }">
                                </i>

                                <!-- Ícono para eliminar casos -->
                                <!--
                                <i class='fe-trash-2' (click)="!disableNoAdmin && navigateToDelete('casos', record.id)"
                                    [ngClass]="{ 'disabled-icon': disableNoAdmin }">
                                </i>
                                -->
                            </ng-container>


                            <ng-container *ngIf="column.name === 'accionesPartes'">
                                <!-- Ícono para agregar representantes -->
                                <i class='fe-user-plus'
                                    (click)="!disableOptions && navigateToRepresentantes('partes', record.id)"
                                    [ngClass]="{ 'disabled-icon': disableOptions  }">
                                </i>

                                <!-- Ícono para editar parte -->
                                <i class='fe-edit' (click)="!disableOptions && navigateToEditParte('partes', record.id)"
                                    [ngClass]="{ 'disabled-icon': disableOptions }">
                                </i>

                                <!-- Ícono para eliminar parte -->
                                <i class='fe-trash-2'
                                    (click)="!disableOptions && !disableNoAdmin && navigateToDelete('partes', record.id)"
                                    [ngClass]="{ 'disabled-icon': disableOptions || disableNoAdmin }">
                                </i>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'accionesPagos'">
                                <!-- Ícono para eliminar pagos con color y click deshabilitados si disableOptions es true -->
                                <i class='fe-trash-2' (click)="!disableOptions && navigateToDelete('pagos', record.id)"
                                    [ngClass]="{ 'disabled-icon': disableOptions }">
                                </i>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'accionesBuscadorArchivos'">
                                <i class='fe-folder' (click)="handleAction('navigateToFolder', record.folderId)"></i>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'accionesHitosProcesales'">
                                <!-- Ícono para eliminar pagos con color y click deshabilitados si disableOptions es true -->
                                <i class='fe-trash-2' (click)="!disableOptions && navigateToDelete('hitos', record.id)"
                                    [ngClass]="{ 'disabled-icon': disableOptions }">
                                </i>
                            </ng-container>

                            <ng-container *ngIf="column.name === 'accionesDiasInhabiles'">
                                <i class='fe-trash-2' (click)="!disableOptions && navigateToDelete('hitos', record.id)"
                                    [ngClass]="{ 'disabled-icon': disableOptions }">
                                </i>
                            </ng-container>

                        </div>
                    </ng-template>
                </td>

                <!--
                <td *ngFor="let column of columns">
                    <div [innerHtml]="callFormatter(column,record)"></div>
                </td>
                -->
            </tr>
        </tbody>
    </table>


    <div class="d-flex flex-wrap justify-content-center align-items-center justify-content-sm-between mt-2"
        *ngIf="pagination">
        <div>
            <span i18n>Mostrando</span> {{service.startIndex }} <span i18n>a</span>
            {{service.endIndex}} <span i18n>de</span> {{service.totalRecords}} <span i18n>entradas</span>
        </div>
        <ngb-pagination class="custom-pagination" [collectionSize]="service.totalRecords" [(page)]="service.page"
            [maxSize]="3" [rotate]="true" [pageSize]="service.pageSize" (pageChange)="paginate()">
            <ng-template ngbPaginationPrevious><span i18n>Prev</span></ng-template>
            <ng-template ngbPaginationNext><span i18n>Sig</span></ng-template>
        </ngb-pagination>
    </div>

</div>
